import React, { Component } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useHistory,
  useLocation,
} from "react-router-dom";
import "./App.css";

import { HelmetProvider } from "react-helmet-async";
import { useEffect, useState } from "react";

//Utils
import ScrollToTop from "./components/ScrollToTop";

// Components
import Header from "./components/menu/Header";
import Footer from "./components/footer/Footer";
import Homepage from "./components/content/Homepage";
import AllCats from "./components/content/AllCats";
import CompareCats from "./components/content/CompareCats";
import AllEnemies from "./components/content/AllEnemies";
import AllStagesByName from "./components/content/AllStagesByName";
import AllStagesByEnemies from "./components/content/AllStagesByEnemies";
import FAQ from "./components/content/FAQ";
import PrivacyPolicy from "./components/content/PrivacyPolicy";
import EmptyPage from "./components/content/EmptyPage";
import SingleCat from "./components/content/SingleCat";
import SingleEnemy from "./components/content/SingleEnemy";
import SingleStage from "./components/content/SingleStage";
import Attack from "./components/content/bestcats/Attack";
import Health from "./components/content/bestcats/Health";
import Range from "./components/content/bestcats/Range";
import Speed from "./components/content/bestcats/Speed";
import Meatshields from "./components/content/bestcats/Meatshields";
import UltraSouls from "./components/content/tierlist/UltraSouls";
import Dynamites from "./components/content/tierlist/Dynamites";
import GalaxyGals from "./components/content/tierlist/GalaxyGals";
import Almighties from "./components/content/tierlist/Almighties";
import Lugas from "./components/content/tierlist/Lugas";
import ReactGA from "react-ga4";
import useGaTracker from "./useGaTracker";
// npm install https://github.com/thomasseelh/react-ga.git
// import GA from './components/ga/GoogleAnalytics';

import HeaderKR from "./components-kr/menu/Header";
import FooterKR from "./components-kr/footer/Footer";
import HomepageKR from "./components-kr/content/Homepage";
import AllCatsKR from "./components-kr/content/AllCats";
import CompareCatsKR from "./components-kr/content/CompareCats";
import AllEnemiesKR from "./components-kr/content/AllEnemies";
import AllStagesByNameKR from "./components-kr/content/AllStagesByName";
import AllStagesByEnemiesKR from "./components-kr/content/AllStagesByEnemies";
import FAQKR from "./components-kr/content/FAQ";
import PrivacyPolicyKR from "./components-kr/content/PrivacyPolicy";
import EmptyPageKR from "./components-kr/content/EmptyPage";
import SingleCatKR from "./components-kr/content/SingleCat";
import SingleEnemyKR from "./components-kr/content/SingleEnemy";
import SingleStageKR from "./components-kr/content/SingleStage";

export const initGA = () => {
  ReactGA.initialize(
    "G-MX6GYDK28N"
    // , {
    //   gaAddress: "https://onestoppress.com/analytics.js"
    // }
  );
};

export const logPageView = () => {
  ReactGA.set({ page: window.location.pathname + window.location.search });
};

const App = () => {
  // const [isTransitioning, setIsTransitioning] = useState(false);
  // const history = useHistory();
  // const setTransitionStarted = () => {
  //   setIsTransitioning(true);

  // destroy all ad slots
  // const { googletag } = window;
  // googletag.cmd.push(function () {
  //   googletag.destroySlots();
  // });
  // const script = document.createElement("script");
  // script.src = "https://cdn.thisiswaldo.com/static/js/14633.js";
  // script.async = true;
  // document.body.appendChild(script);

  // script.onload = () => {
  // Call the function after the script is loaded
  // window.domainCheckPass = window.adDomainCheck();
  // };
  // };
  // const setTransitionComplete = () => {
  // setIsTransitioning(false);
  // };

  // useEffect(() => {
  //   const unlistenStart = history.listen(setTransitionStarted);
  //   const unlistenComplete = history.listen(setTransitionComplete);

  //   return () => {
  //     unlistenStart();
  //     unlistenComplete();
  //   };
  // }, [history]);
  useGaTracker();
  const location = useLocation();

  return (
    <HelmetProvider>
      <div>
        {location.pathname.startsWith("/kr") ? <HeaderKR /> : <Header />}
        <ScrollToTop />
        <Switch>
          {/* Engish Version Routes */}
          <Route exact path="/" component={Homepage} />
          <Route exact path="/allcats" component={AllCats} />
          <Route exact path="/comparecats" component={CompareCats} />
          <Route exact path="/catinfo/:catno/:catname" component={SingleCat} />
          <Route exact path="/allenemies" component={AllEnemies} />
          <Route
            exact
            path="/enemyinfo/:enemy_no/:enemy_name_en/:mult?"
            component={SingleEnemy}
          />
          <Route
            exact
            path="/allstages/search-by-stage-name"
            component={AllStagesByName}
          />
          <Route
            exact
            path="/allstages/search-by-stage-enemies"
            component={AllStagesByEnemies}
          />
          <Route
            exact
            path="/stageinfo/:stageid/:stagename?"
            component={SingleStage}
          />
          <Route exact path="/faq" component={FAQ} />
          {/* <Route exact path="/merchandise" component={Merchandise} /> */}
          <Route exact path="/privacypolicy" component={PrivacyPolicy} />
          <Route exact path="/best-cats-for-attack" component={Attack} />
          <Route exact path="/best-cats-for-health" component={Health} />
          <Route exact path="/best-cats-for-range" component={Range} />
          <Route exact path="/best-cats-for-speed" component={Speed} />
          <Route
            exact
            path="/best-cats-for-meatshields"
            component={Meatshields}
          />
          {/* <Route exact path="/best-cats-for-testads" component={Testads} /> */}
          <Route exact path="/ultra-souls-tier-list" component={UltraSouls} />
          <Route exact path="/dynamites-tier-list" component={Dynamites} />
          <Route exact path="/galaxy-gals-tier-list" component={GalaxyGals} />
          <Route exact path="/almighties-tier-list" component={Almighties} />
          <Route exact path="/lugas-tier-list" component={Lugas} />

          {/* Korean Version Routes */}
          <Route exact path="/kr" component={HomepageKR} />
          <Route exact path="/kr/allcats" component={AllCatsKR} />
          <Route exact path="/kr/comparecats" component={CompareCatsKR} />
          <Route
            exact
            path="/kr/catinfo/:catno/:catname"
            component={SingleCatKR}
          />
          {/* <Route exact path="/kr/allenemies" component={AllEnemiesKR} />
          <Route
            exact
            path="/kr/enemyinfo/:enemy_no/:enemy_name_en/:mult?"
            component={SingleEnemyKR}
          />
          <Route
            exact
            path="/kr/allstages/search-by-stage-name"
            component={AllStagesByNameKR}
          />
          <Route
            exact
            path="/kr/allstages/search-by-stage-enemies"
            component={AllStagesByEnemiesKR}
          />
          <Route
            exact
            path="/kr/stageinfo/:stageid/:stagename?"
            component={SingleStageKR}
          />
          <Route exact path="/kr/faq" component={FAQKR} />
          <Route exact path="/kr/privacypolicy" component={PrivacyPolicyKR} /> */}

          <Route path="*" component={EmptyPage}></Route>
        </Switch>
        {location.pathname.startsWith("/kr") ? <FooterKR /> : <Footer />}
      </div>
    </HelmetProvider>
  );
};

export default App;



// WEBPACK FOOTER //
// ./src/App.js